import './RecordSecondaryInfo.scss';
import { Col } from 'antd';
import { getSonarObjectTypeAndSourceLabel } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { When } from 'react-if';

export interface SonarRecordSecondaryInfoProps {
	info?: string | React.ReactNode;
	sonarObjectType?: SonarObjectType;
}

export const SonarRecordSecondaryInfo: React.FC<SonarRecordSecondaryInfoProps> = ({ info, sonarObjectType }) =>
	<When condition={ Boolean(info) || sonarObjectType }>
		<Col
			className='secondary-info'
			flex='auto'>
			<When condition={ sonarObjectType }>
				<div>{ getSonarObjectTypeAndSourceLabel(sonarObjectType as SonarObjectType) }</div>
			</When>
			<When condition={ Boolean(info) }>
				<div>{ info }</div>
			</When>
		</Col>
	</When>;
